import { ICreateWorkspaceInvitationPayload, IUpdateWorkspaceInvitationPayload } from '../entities/IAdmin';

export const getCreateWorkspaceInvitationPath = (allEntities: boolean): string => (
    allEntities
        ? '/business-rules/default-organizations'
        : '/business-rules/legal-entity/default-organizations'
);

export const getUpdateWorkspaceInvitationPath = (
    originalAllEntities: boolean,
    previousLegalEntityId: string | undefined,
    previousOrganizationId: string
): string => (
    originalAllEntities
        ? `/business-rules/default-organizations/${previousOrganizationId}`
        : `/business-rules/legal-entity/${previousLegalEntityId}/default-organizations/${previousOrganizationId}`
);

export const getDeleteWorkspaceInvitationPath = (
    allEntities: boolean,
    legalEntityId: string | undefined,
    organizationId: string,
    ruleName: string
): string => {
    const base = allEntities
        ? `/business-rules/default-organizations/${organizationId}`
        : `/business-rules/legal-entity/${legalEntityId}/default-organizations/${organizationId}`;
    return `${base}?ruleName=${encodeURIComponent(ruleName)}`;
};

export const buildCreateWorkspaceInvitationPayload = (
    allEntities: boolean,
    legalEntityIds: string[],
    organizationIds: string[],
    roleInOrganization: string,
    sendNotification: boolean,
    expression?: string
): ICreateWorkspaceInvitationPayload => ({
    // tslint:disable-next-line:no-null-keyword -- API expects explicit null when All entities is on
    legalEntityIds: allEntities ? null : legalEntityIds,
    organizationIds,
    roleInOrganization,
    sendNotification,
    ...(allEntities ? { expression: (expression || '').trim() } : {})
});

export const buildUpdateWorkspaceInvitationPayload = (
    allEntities: boolean,
    legalEntityId: string | undefined,
    organizationId: string,
    roleInOrganization: string,
    sendNotification: boolean,
    ruleName: string,
    expression?: string
): IUpdateWorkspaceInvitationPayload => ({
    allEntities,
    // tslint:disable-next-line:no-null-keyword -- API expects explicit null when All entities is on
    legalEntityId: allEntities ? null : (legalEntityId || undefined),
    organizationId,
    roleInOrganization,
    sendNotification,
    ruleName,
    ...(allEntities ? { expression: (expression || '').trim() } : {})
});
